import Vue from "vue"
import Router from "vue-router"
import Home from "@/views/common/home"
import Answer from "@/views/common/answer"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      // meta: {
      //   title: "着迷网话题详情页",
      //   keepAlive: false,
      // },
    },
    {
      path: "/answer",
      name: "answer",
      component: Answer,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js